<template>
    <div class="lower-list-box">
        <div class="filter-container">
            <div class="filter-box">
                <div class="filter-item" style="min-width:430px">
                    <span style="margin-right: 10px;">注册时间：</span>
                    <el-date-picker v-model="filteDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="onChangeDateRange">
                    </el-date-picker>
                </div>
                <div class="filter-item">
                    <el-input v-model="listQuery.user_account_name" placeholder="用户名/电话" clearable />
                </div>
                <div class="filter-item">
                    <el-select v-model="listQuery.perfect" placeholder="资料完善" clearable>
                        <el-option label="完善" :value="1" />
                        <el-option label="缺失" :value="0" />
                    </el-select>
                </div>
                <div class="filter-item">
                    <el-select v-model="listQuery.type" placeholder="状态" clearable>
                        <el-option label="正常" :value="1" />
                        <el-option label="冻结" :value="0" />
                    </el-select>
                </div>
            </div>
            <div class="filter-button">
                <el-button type="primary" :loading="listLoading" icon="el-icon-search" @click="handleFilter">搜索</el-button>
                <el-button type="warning" :loading="listLoading" icon="el-icon-upload2" @click="exportExcel">导出Excel</el-button>
            </div>
        </div>

        <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" size="small" border fit
            highlight-current-row>
            <el-table-column prop="user_info.id" align="center" label="ID" min-width="60" />
            <el-table-column label="头像" min-width="60" align="center">
                <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px" :src="scope.row.user_info.head_img" fit="cover"></el-image>
                </template>
            </el-table-column>
            <el-table-column prop="user_info.name" label="昵称" min-width="80" align="center" />
            <el-table-column prop="user_info.account" label="联系电话" min-width="80" align="center" />
            <el-table-column label="性别" min-width="50" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.user_info.gender === 0 || scope.row.user_info.gender === null">未设置</span>
                    <span v-else-if="scope.row.user_info.gender === 1">男</span>
                    <span v-else-if="scope.row.user_info.gender === 2">女</span>
                    <span v-else>后端无字段</span>
                </template>
            </el-table-column>
            <el-table-column label="是否完善资料" min-width="95" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.user_info.perfect === 1" type="success">
                        是
                    </el-tag>
                    <el-tag v-else type="danger">
                        否
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="年龄段" min-width="60" align="center">
                <template slot-scope="scope">
                    <div>{{
                        scope.row.user_info.age_group === 1 ? '20岁以下' :
                        scope.row.user_info.age_group === 2 ? '21~30岁' :
                            scope.row.user_info.age_group === 3 ? '31~40岁' :
                                scope.row.user_info.age_group === 4 ? '41~50岁' : 
                                    scope.row.user_info.age_group === 5 ? '51岁以上' :'未设置'
                    }}</div>
                </template>
            </el-table-column>

            <el-table-column prop="user_info.wx_id" label="微信ID" min-width="60" align="center" />

            <el-table-column label="居住地" min-width="80" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.user_info.country && scope.row.user_info.provinces">
                        {{ scope.row.user_info.country }} ，{{ scope.row.user_info.provinces }}
                    </div>
                    <div v-else>
                        无
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="user_info.invite_num" label="邀请人数" min-width="80" align="center" />

            <!-- <el-table-column prop="invite_num" label="渠道来源" min-width="80" align="center" /> -->

            <el-table-column prop="user_info.integral" label="积分" min-width="60" align="center" />
            <el-table-column prop="user_info.raffle_num" label="抽奖次数" min-width="80" align="center" />
            <el-table-column prop="user_info.created_at" label="注册时间" min-width="80" align="center" />
            <el-table-column prop="user_info.last_login_at" label="最近登陆时间" min-width="95" align="center" />
            <el-table-column class-name="status-col" label="状态" min-width="60" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.user_info.type === 1" type="primary">正常</el-tag>
                    <el-tag v-else-if="scope.row.user_info.type === 0" type="warning">冻结</el-tag>
                    <el-tag v-else>后端无字段</el-tag>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50, 100]" :page-size="listQuery.limit"
                :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" />
        </div>
    </div>
</template>
<script>
import { channel } from "@/api/operation";
import {platformList} from "@/utils/common"
import * as XLSX from "xlsx";
export default {
    data() {
        return {
            list: [],
            total: 0,
            listLoading: false,
            listQuery: {
                id: null,
                page: 1,
                limit: 10,
                time_1: null,
                time_2: null,
                user_account_name: '',
                type: null,
                perfect: null
            },
            filteDateRange: null,
        }
    },
    props: {
        currentObj: {
            type: Object,
            default: () =>{}
        }
    },
    created(){
        this.listQuery.id = this.currentObj.id
        this.getList()
    },
    methods: {
        async getList() {
            this.listLoading = true;
            this.list = []
            const { data } = await channel.lowerList(this.listQuery)
            this.list = data.data;
            this.total = data.total;

            this.listLoading = false;
        },
        handleFilter() {
            this.listQuery.page = 1
            this.getList();
        },
        onChangeDateRange(t) {
            if (t === null) {
                this.listQuery.time_1 = null
                this.listQuery.time_2 = null
                return
            }
            this.listQuery.time_1 = t[0]
            this.listQuery.time_2 = t[1]
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        async exportExcel() {
            console.log('exportExcel')
            // 修改excel-渠道管理-下级列表-原字段---ok
            const { total } = this
            if (!total) return

            try {
                const { data: { data: reqData } } = await channel.lowerList({ ...this.listQuery, page: 1, limit: 99999999999 })
                console.log(reqData);

                var wb = XLSX.utils.book_new();
                

                
                
                var excelData = [
                    ['ID', '昵称', '性别' ,'年龄','手机号','居住地-国家','居住地-省份','微信ID','邮箱','是否完善资料',   '邀请人数', '积分', '抽奖次数', '注册时间', '最近登陆时间', '状态' ],
                    ...reqData.map((item) => [
                        item.user_info.id, 
                        item.user_info.name, 
                        item.user_info.gender === 1 ? '男性' : item.user_info.gender === 2 ? '女性' : '未设置',
                        item.user_info.age_group === 1 ? '20岁以下' : item.user_info.age_group === 2 ? '21~30岁' : item.user_info.age_group === 3 ? '31~40岁' : item.user_info.age_group === 4 ? '41~50岁' : item.user_info.age_group === 5 ? '51岁以上' : '未设置',
                        item.user_info.account,
                        item.user_info.country,
                        item.user_info.provinces,
                        item.user_info.wx_id,
                        item.user_info.email,
                        item.user_info.perfect ? '是' : '否',
                        item.user_info.invite_num, 
                        item.user_info.integral, 
                        item.user_info.raffle_num, 
                        item.user_info.created_at, 
                        item.user_info.last_login_at, 
                        item.user_info.type ? '正常' : '冻结'
                    ])
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);


                XLSX.utils.book_append_sheet(wb, ws, "下级列表");
                XLSX.writeFile(wb, "渠道管理-下级列表.xlsx");

                this.$notify.info({
                    title: '消息',
                    message: '请等待, 正在生成Excel表格文件...'
                });
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.lower-list-box {
    width: 100%;
    overflow: hidden;
    .filter-container {
        display: flex;
        flex-wrap: nowrap;
        // min-height: 110px;

        .filter-box{
            display: flex;
            justify-content: flex-end;
            flex-wrap: wrap;

            .filter-item {
                text-align: center;
                padding-bottom: 5px;

                .filter-name {
                    font-size: 13px;
                    margin-right: 6.5px;
                    color: #606266;
                }
            }
        }
        .filter-button{
            min-width: 223px;
        }
        
    }
}
</style>